export default "__VITE_ASSET__CIMTj2hs__"